import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  EReportColumnHeader,
  EReportingTimeWindow,
  IReportingAudiencesTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { coreAPI } from '../services/coreAPI'
import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAudiencesReportTableFilters,
  TDOOHAudiencesReportTableFilters,
  TPPRetailerId,
} from '../models/types'

export default function useGetRetailerReportingAudiencesTableV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TDAAudiencesReportTableFilters | TDOOHAudiencesReportTableFilters) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingAudiencesTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAudiencesTable_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPI.v2RetailerReporting().getRetailerAudiencesReportTable(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        adGroupId,
        channelType as EParamChannelTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
